// src/components/common/Navbar.js
import React from 'react';
import LogoutIcon from '@mui/icons-material/Logout';
import { AppBar, Toolbar, Typography, Button, Box, Menu, MenuItem, IconButton } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import HomeIcon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';
import CachedIcon from '@mui/icons-material/Cached';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const Navbar = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography
          variant="h6"
          component={RouterLink}
          to="/"
          sx={{
            flexGrow: 1,
            textDecoration: 'none',
            color: 'inherit',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box component="img" src="/logo.png" alt="Logo" sx={{ height: 40, mr: 1, display: { xs: 'none', sm: 'block' } }} />
        
        </Typography>
        
        <Button
          color="inherit"
          component={RouterLink}
          to="/"
          startIcon={<HomeIcon />}
          sx={{ display: { xs: 'none', sm: 'flex' } }}
        >
          Home
        </Button>
        
        <Button
          color="inherit"
          component={RouterLink}
          to="/upload"
          startIcon={<UploadFileIcon />}
        >
          Upload
        </Button>
        
        <IconButton
          color="inherit"
          onClick={handleClick}
          aria-controls={open ? 'admin-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <MoreVertIcon />
        </IconButton>
        
        <Menu
          id="admin-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'admin-button',
          }}
        >
          <MenuItem 
            component={RouterLink} 
            to="/admin/cache" 
            onClick={handleClose}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <CachedIcon fontSize="small" sx={{ mr: 1 }} />
            Cache Management
          </MenuItem>
          <MenuItem onClick={handleClose} sx={{ display: 'flex', alignItems: 'center' }}>
            <SettingsIcon fontSize="small" sx={{ mr: 1 }} />
            Settings
          </MenuItem>
          <MenuItem 
            onClick={() => {
              localStorage.removeItem('isAuthenticated');
              window.location.reload();
            }}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
